import { FC } from 'react';
import { CheckSolidIcon, ExclamationSolidIcon } from '@fiverr-private/icons';
import { StatusColorsType } from '@fiverr-private/fit';
import { THEMES } from './constants';

interface ThemeConfigType {
    statusIcon: FC;
    color: StatusColorsType;
}

const THEME_CONFIG: { [key: string]: ThemeConfigType } = {
    [THEMES.SUCCESS]: {
        statusIcon: CheckSolidIcon as any,
        color: 'green'
    },
    [THEMES.ERROR]: {
        statusIcon: ExclamationSolidIcon as any,
        color: 'red'
    }
};

export default THEME_CONFIG;
